export default "__VITE_ASSET__b9cCKNpJ__"